import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import * as moment from 'moment';

enum calendarViewTypes {
    YEAR = 'year',
    MONTH = 'month'
}

@Component({
  selector: 'app-calendar-calendar',
  templateUrl: './calendar-calendar.component.html',
  styleUrls: ['./calendar-calendar.component.css']
})
export class CalendarCalendarComponent implements OnInit {
    calendar: any;
    months: any;
    year: number; // year to display if calendar type: year is selected
    month: number; // month to display if calendar type: month is selected
    viewtype: calendarViewTypes;
    calendarViewTypes;
    // todo: allow to display a week view too
    constructor(protected apiService: ApiService) {
        this.viewtype = calendarViewTypes.YEAR;
        this.calendarViewTypes = calendarViewTypes;
        this.year = moment().year();
        this.month = moment().month();
        this.apiService.getAll('calendar').subscribe((val) => {
            this.calendar = val;
            console.log('got calendar items:', this.calendar);
            this.addRepititions();
            this.getMonths();
        });
    }

    protected addRepititions() {
        console.log('this.calendar inside addRepitions: ', this.calendar);
        const length = this.calendar.length;
        for (let eventIterator = 0; eventIterator < length; eventIterator++) {
            const event = this.calendar[eventIterator];

            console.log('testing repetition for event:', event);
            if (event.repeats !== 'no') {
                const day = new Date(event.date);
                let counter = 0;
                let increment = 0;
                switch (event.repeats) {
                    case '1':
                        increment = 1;
                        break;
                    case '2':
                        increment = 2;
                        break;
                    case '3':
                        increment = 7;
                        break;
                }
                console.log('event:', event);
                console.log('day', day);
                console.log('increment', increment);
                console.log('day full year:', day.getFullYear());
                console.log('this.year:', this.year);
                console.log('nrrepititions:', event.nrrepititions);
                for (let a = 0; a < event.nrrepititions; a++) {
                    let currentDate = day.getDate();
                    currentDate += increment;
                    day.setDate(currentDate);
                    const dayCopy = new Date(day);
                    const eventCopy = Object.assign({}, this.calendar[eventIterator]);
                    eventCopy.title += String(a);

                    eventCopy.date = dayCopy;
                        console.log('adding day to calendar:', eventCopy);
                        this.calendar.push(eventCopy); // add day to calendar - it's an event that got repeated on other days too
                }
                // do {
                //     day.setDate(day.getDate() + increment);
                //     console.log('adding day to calendar:', day);
                //     this.calendar.push(day); // add day to calendar - it's an event that got repeated on other days too
                //     counter++;
                // } while (day.getFullYear() === this.year && counter <= event.nrrepititions && counter < 2);
            }
        }
        console.log('calendar after adding repitions:', this.calendar);
    }

    // when in year view, allows to switch to next year
    public nextYear() {
        this.year++;
        this.getMonths();
    }

    // when in year view, allows to switch to previous year
    public prevYear() {
        this.year--;
        this.getMonths();
    }

    // when in month view, allows to switch to next month
    public nextMonth() {
        this.month++;
        if (this.month > 11) {
            this.month = 0;
            this.year++;
            this.getMonths();
        }
    }

    // when in month view, allows to switch to previous month
    public prevMonth() {
        this.month--;
        if (this.month < -1) {
            this.month = 11;
            this.year--;
            this.getMonths();
        }
    }

    // allows to switch between year, month, maybe week
    public setViewType(viewType: calendarViewTypes) {
        this.viewtype = viewType;
    }

    // fills calendar with months
    protected getMonths() {
        this.months = new Array();
        for (let a = 0; a < 12; a++) {
            this.months.push(this.getMonth(a));
        }
    }

    // gets all days for one month
    public getMonth(month) {
        const firstDayOfMonth = moment().year(this.year).month(month).date(0).day();
        const monthName = moment().year(this.year).month(month).format('MMMM');
        const daysOfLastMonth = new Array();
        const weeks = new Array();
        let calendarDay = 0 - firstDayOfMonth;
        let daysMonth;
        let nextDaysMonth = month;
        do {
            const week = new Array();
            // get all days for one week
            for (let i = 1; i < 8; i++) {
                calendarDay++;
                daysMonth = moment().year(this.year).month(month).date(calendarDay).month();
                const day = moment().year(this.year).month(month).date(calendarDay).date();
                let monthType = 0; // is it a day from the previous month, current month or next month
                const monthCalendar = this.calendar.filter((val) => {
                    const event = new Date(val.date);
                    const eventDay = event.getDate();
                    const eventMonth = event.getMonth();
                    return event.getDate() === day && event.getMonth() === daysMonth && event.getFullYear() === this.year;
                });
                // todo: fof calendar, don't ignore the year
                if (daysMonth > month && calendarDay > 1) {
                    monthType = 1;
                } else if (
                    (daysMonth > month && calendarDay < 0)
                    ||
                    (daysMonth < month)
                ) {
                    monthType = -1;
                }
                const hasCalendar = monthCalendar.length > 0 && monthType === 0;
                const calendarOnThisDay = monthCalendar.map((val) => {
                    const event = new Date(val.date);
                    const age = this.year - event.getFullYear();
                    let title = val.title + '\r\n' + val.description;
                    if (val.allday === '1') {
                        title += '\r\n(All day)';
                    } else {
                        title += '\r\n(' + val.duration + ' ' + val.durationunit + ')';
                    }
                    return title;
                }); // .join('\r\n');
                const isToday =
                    day === moment().date()
                    && daysMonth === moment().month()
                    && this.year === moment().year();
                week.push({day: day, month: monthType, isToday: isToday, hasCalendar: hasCalendar, calendarOnThisDay: calendarOnThisDay});
            }
            nextDaysMonth = moment().year(this.year).month(month).date(calendarDay + 1).month();
            weeks.push(week);
        } while (month === nextDaysMonth);
        return {monthName: monthName, weeks: weeks};
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar-calendar/calendar-calendar.component.ts